const stlBlue = '#1289d4';
export const dialogStyles = {
	dialogScroll: {
		fontSize: '2.5vw',
		padding: '2vw 2vw',
	},
	dialogRoot: {
		fontSize: '2.5vw',
		padding: '2vw 2vw',
	},
	dialogPaper: {
		width: 'calc(100% - 32px)',
		margin: '2vw',
		padding: '2vw 2vw',
	},
	dialogContent: {
		padding: '2.5vw 2.5vw',
		paddingTop: '4vw',
		overflowY: 'unset',
	},
	inner: {
		padding: '2vw 2.5vw',
	},
	dialogTitle: {
		fontSize: '150%',
		borderBottom: '1px solid #eee',
		paddingBottom: '.5vw',
		marginBottom: '1vw',
		fontWeight: 500,
		display: 'flex',
		justifyContent: 'space-between',
	},
	dialogSubmitButton: {
		fontWeight: 'bold',
		fontSize: '110%',
		//backgroundColor: stlBlue,
		color: 'white',
		padding: `3.33vw 5.8vw`,
		lineHeight: 1,
		borderRadius: 4,
		marginRight: '2.5vw',
		marginTop: '1.6vw',
		marginBottom: '1.6vw',
		minWidth: '40vw',
		width: '100%',
	},
	dialogSecondaryButton: {
		fontWeight: 'bold',
		fontSize: '110%',
		color: stlBlue,
		padding: `3.33vw 5.8vw`,
		lineHeight: 1,
		borderRadius: 4,
		marginRight: '2.5vw',
		marginTop: '1.6vw',
		marginBottom: '1.6vw',
		minWidth: '40vw',
		width: '100%',
	},
	dialogCloseButton: {
		fontWeight: 'bold',
		fontSize: '110%',
		padding: `3.33vw 5.8vw`,
		lineHeight: 1,
		borderRadius: 4,
		marginTop: '1.6vw',
		marginBottom: '1.6vw',
		minWidth: '40vw',
		width: '100%',
		background: 'white',
		color: '#666',
	},
};
